import { render, staticRenderFns } from "./mark.vue?vue&type=template&id=325b5962&scoped=true"
import script from "./mark.vue?vue&type=script&lang=ts"
export * from "./mark.vue?vue&type=script&lang=ts"
import style0 from "./mark.vue?vue&type=style&index=0&id=325b5962&prod&lang=scss"
import style1 from "./mark.vue?vue&type=style&index=1&id=325b5962&prod&lang=scss&scoped=true"
import style2 from "./mark.vue?vue&type=style&index=2&id=325b5962&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "325b5962",
  null
  
)

export default component.exports